import { ApiResponse } from 'services/_api';
import { ReducerActionRotaSP } from 'store/modules/types';

import { IncluirRequest, Types } from './types';

export function estatisticaIncluirRequest(
	token: string,
	data: IncluirRequest,
): ReducerActionRotaSP {
	return {
		type: Types.ESTATISTICA_INCLUIR_REQUEST,
		payload: data,
		token,
	};
}
export function estatisticaIncluirSuccess(
	payload: ApiResponse,
): ReducerActionRotaSP {
	return {
		type: Types.ESTATISTICA_INCLUIR_SUCCESS,
		payload,
	};
}
export function estatisticaIncluirFailure(
	payload: string,
): ReducerActionRotaSP {
	return {
		type: Types.ESTATISTICA_INCLUIR_FAILURE,
		payload,
	};
}
export function estatisticaIncluirClear(): { type: string } {
	return {
		type: Types.ESTATISTICA_INCLUIR_CLEAR,
	};
}
